import { useAppSelector } from '@hooks/useRedux';
import { selectDiningSectionIds } from '@store/runningOrder';
import React from 'react';
import { ONBOARDING_TOUR_TARGETS } from '../../services/onboardingTourService';
import { SectionCollapsible } from './SectionCollapsible';

export const DiningPanel: React.FC = () => {
  const sectionIds = useAppSelector(selectDiningSectionIds);

  return (
    <div
      className="h-full overflow-y-auto bg-white"
      data-onboarding-tour={ONBOARDING_TOUR_TARGETS.salesDiningPanel}
    >
      {sectionIds.length === 0 ? (
        <div className="flex h-40 items-center justify-center px-4 text-center text-sm italic text-gray-500">
          No sections configured
        </div>
      ) : (
        sectionIds.map((sectionId, index) => (
          <SectionCollapsible
            key={sectionId}
            isTourPrimary={index === 0}
            sectionId={sectionId}
          />
        ))
      )}
    </div>
  );
};
